import { HttpInterceptorFn, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, finalize, switchMap, tap } from "rxjs/operators";
import { AuthService } from "../auth/auth.service";
import { LoaderService } from "../loaderSpinner/loader.service";
import { API_URL } from "src/environments/environment";
import { from } from "rxjs";
import { getToken } from "firebase/app-check";
import { appCheck } from "../firebase";

export const appLoggingInterceptor: HttpInterceptorFn = (req, next) => {
  console.log("HTTP request:", req.method, req.url);

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          console.log("HTTP response:", event.status, req.url);
        }
      },
      error: (error) => console.log("HTTP error:", error),
    }),
  );
};

export const appAuthInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);

  return authService.getToken().pipe(
    switchMap((token: string | null) => {
      if (!token) {
        return next(request);
      }

      const reqCopy = request.clone({
        setHeaders: {
          Authorization: `${token}`,
        },
      });

      return next(reqCopy);
    }),
  );
};

let activeRequests = 0;

export const appLoaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  if (req.url.includes("librarydocument/create")) {
    return next(req);
  }

  loaderService.show();
  activeRequests++;

  return next(req).pipe(
    finalize(() => {
      activeRequests--;

      if (activeRequests === 0) {
        loaderService.hide();
      }
    }),
  );
};

export const appCheckInterceptor: HttpInterceptorFn = (req, next) => {
  const isMyApi = req.url.includes(API_URL);
  if (!isMyApi) {
    return next(req);
  }
  return from(getToken(appCheck, false)).pipe(
    switchMap((appCheckResult) => {
      if (appCheckResult.token) {
        const reqCopy = req.clone({
          setHeaders: {
            "X-Firebase-AppCheck": appCheckResult.token,
          },
        });
        return next(reqCopy);
      }
      return next(req);
    }),
    catchError((err) => {
      console.warn("App Check token fetch failed:", err);
      return next(req);
    }),
  );
};
